import React from "react";
import type { Dispatch } from "react";
import type { SelectableChatBoxListAction, SelectableChatBoxListState } from "../types";
import { useWindowNativeEventListener } from "../../../hooks/use-window-native-event-listener";
import { DATA_SELECTABLE_ITEM_ID } from "../../../constants";
import { $Logger } from "../../../../logger";

const getContainerById = (id: string | undefined) => {
	if (!id) return null;
	return window.document.getElementById(id);
};

const DRAG_DIRECTION_MINIMUM = 50;

export type UseDragSelectProps = {
	chatBoxListId?: string;
	state: SelectableChatBoxListState;
	dispatch: Dispatch<SelectableChatBoxListAction>;
};
export const useDragSelect = (props: UseDragSelectProps) => {
	const { chatBoxListId, state } = props;
	const mouseDownCblPositionRef = React.useRef<{ x: number; y: number } | null>(null);

	React.useEffect(() => {
		const container = getContainerById(chatBoxListId);
		if (!container) return;

		const handleMouseDown = (e: MouseEvent) => {
			mouseDownCblPositionRef.current = { x: e.clientX, y: e.clientY };
		};
		container.addEventListener("mousedown", handleMouseDown);
		return () => container.removeEventListener("mousedown", handleMouseDown);
	}, [chatBoxListId]);

	useWindowNativeEventListener(window, "mousemove", (event) => {
		const mouseDownCblPosition = mouseDownCblPositionRef.current;
		if (!mouseDownCblPosition) return;

		const container = getContainerById(chatBoxListId);
		if (!container) return;

		const currentPosition = { x: event.clientX, y: event.clientY };
		const deltaY = Math.abs(currentPosition.y - mouseDownCblPosition.y);
		$Logger.log("Drag deltaY: ", deltaY);

		if (deltaY < DRAG_DIRECTION_MINIMUM) return;

		const newSelectedItemsMap: Record<string, string> = {};

		const items = container.querySelectorAll<HTMLElement>(`[${DATA_SELECTABLE_ITEM_ID}]`);
		const tupleY = [mouseDownCblPosition.y, currentPosition.y];
		const yMin = Math.min(...tupleY);
		const yMax = Math.max(...tupleY);
		items.forEach((item) => {
			const { y: yItem, bottom: bottomItem } = item.getBoundingClientRect();
			const intersectionSegment = Math.max(
				0,
				Math.min(bottomItem, yMax) - Math.max(yItem, yMin),
			);
			const intersectionPercent = intersectionSegment / (bottomItem - yItem);
			if (intersectionPercent >= 0.5) {
				const selectKey = item.dataset.selectableItemId;
				if (selectKey) {
					newSelectedItemsMap[selectKey] = selectKey;
				}
			}
		});

		// const currentSelectedItemsMap = state.selectedItemsMap;
		// const loopLength = Math.max(
		// 	...[newSelectedItemsMap, currentSelectedItemsMap].map((m) => Object.values(m).length),
		// );
		// const biggerMap =
		// 	loopLength ===
		// 	Object.values(currentSelectedItemsMap).length
		// 		? currentSelectedItemsMap
		// 		: newSelectedItemsMap;

		// const result: Record<string, string> = {};
		// for (const [key, value] of Object.entries(biggerMap)) {
		// 	if (newSelectedItemsMap[key] && currentSelectedItemsMap[key]) {
		// 	} else {
		// 		result[key] = value;
		// 	}
		// }

		props.dispatch({
			type: "overwrite-selected-items-map",
			payload: { selectedItemsMap: newSelectedItemsMap },
		});
	});

	useWindowNativeEventListener(window, "mouseup", () => {
		mouseDownCblPositionRef.current = null;
	});

	useWindowNativeEventListener(window, "contextmenu", () => {
		mouseDownCblPositionRef.current = null;
	});
};
